export const RD_ANALYTICS_ID = 'rd_analytics'
export const SEND_GOOGLE_RESERVE_CONVERSION_DATA = 'SEND_GOOGLE_RESERVE_CONVERSION_DATA'

export const ANALYTICS_FLOW_TYPE_PARK_NOW = 'Park Now'
export const ANALYTICS_FLOW_TYPE_BOOK_ADVANCE = 'Book In Advance'
export const ANALYTICS_FLOW_TYPE_EVENT = 'Event'
export const ANALYTICS_FLOW_TYPE_SCAN_TICKET = 'Scan Ticket'
export const ANALYTICS_FLOW_TYPE_SUBSCRIPTION = 'Subscription'
